import hopeTheme from '../../../styles/themes/hopeTheme';

export const arrowToggleColor = '#a9a9a9';
export const arrowToggleDownColor = hopeTheme.hopeBlack;

export const listStyles = {
  innerDivStyle: {
    marginLeft: 30,
    padding: 10,
    fontSize: 16,
  },
  style: {
    fontSize: 16,
    letterSpacing: '-0.3px',
    WebkitAppearance: 'none',
    color: hopeTheme.textColor,
  },
};

export const nestedListStyles = {
  innerDivStyle: {
    padding: 10,
    marginLeft: 50,
    fontSize: 16,
  },
  style: {
    fontSize: 16,
    letterSpacing: '-0.3px',
    WebkitAppearance: 'none',
    color: hopeTheme.textColor,
  },
};

export const innerListStyle = {
  marginLeft: 30,
  padding: 10,
  fontSize: 16,
};

export const nestedListStyle = {
  marginLeft: 30,
  fontSize: 16,
};

export const innerNestedListStyle = {
  padding: 10,
  marginLeft: 50,
  fontSize: 16,
};

export const dividerStyle = { backgroundColor: '#DDDDDD' };

export const visibleToastStyle = { bottom: hopeTheme.toast.height };

export const containerStyle = {
  boxShadow: 'none',
  fontColor: 'white',
  position: 'fixed',
  top: hopeTheme.navBar.height,
  borderRight: '1px solid #DDDDDD',
  height: 'auto',
  bottom: 0,
  zIndex: 1900,
};

export const smallContainerStyle = {
  boxShadow: 'none',
  height: 'auto',
  top: 0,
  bottom: 0,
  borderRight: 0,
  zIndex: 3000,
};

export const listItemStyle = {
  fontSize: 16,
  letterSpacing: '-0.3px',
  WebkitAppearance: 'none',
  color: hopeTheme.textColor,
};

export const listStyle = {
  fontSize: 16,
  fontFamily: hopeTheme.fontFamily,
  fontWeight: 600,
  padding: '2px 10px',
  letterSpacing: '1px',
  WebkitAppearance: 'none',
  color: hopeTheme.textColor,
};

export const listHeaderStyle = {
  fontSize: 16,
  fontFamily: hopeTheme.headerBold,
  fontWeight: hopeTheme.weightBold,
  textTransform: 'uppercase',
  padding: '2px 4px',
  letterSpacing: '1px',
  WebkitAppearance: 'none',
  color: hopeTheme.textColor,
  borderBottom: '1px solid #ddd',
};

export const listSubHeaderStyle = {
  fontSize: 16,
  fontFamily: hopeTheme.headerMedium,
  fontWeight: 500,
  textTransform: 'uppercase',
  padding: '2px 6px',
  letterSpacing: '1.2px',
  WebkitAppearance: 'none',
  color: hopeTheme.textColor,
};
